// Store your Gemini API key here
export const GEMINI_API_KEY = 'AIzaSyBeGGyVylXyujrkN8BuVrrrX7ouh8Nj9PY';

export const GEMINI_CONFIG = {
  model: 'gemini-2.5-flash-image-preview',
  // Use the correct endpoint for image generation
  apiEndpoint: 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-image-preview:generateContent',
  // Alternative endpoint that might be needed for image generation
  imageEndpoint: 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-image-preview:generateImage'
};